import { Link } from "react-router-dom";
import { AuthImg } from "@/components/AuthImg";
import { STATE_STYLE } from "@/lib/sales";
import { ImageOff } from "lucide-react";

// One row of a Sales list: the item's photo, its name and code, and why it is here.
export function SalesThumb({ fileId, testid }) {
  return fileId
    ? <AuthImg fileId={fileId} thumb alt="" className="w-16 h-16 sm:w-20 sm:h-20 rounded-lg object-cover shrink-0 bg-slate-100" data-testid={testid} />
    : <div data-testid={testid} className="w-16 h-16 sm:w-20 sm:h-20 rounded-lg bg-slate-100 grid place-items-center shrink-0 text-slate-400"><ImageOff className="w-5 h-5" /></div>;
}

export function StateChip({ state, words, testid }) {
  if (!state) return null;
  return <span data-testid={testid} className={`inline-flex items-center rounded-md border px-2 py-0.5 text-[11px] font-bold uppercase tracking-wide ${STATE_STYLE[state] || ""}`}>{words}</span>;
}

export function SalesTitle({ row, testid }) {
  return (
    <div className="min-w-0">
      <Link to={row.link} data-testid={`${testid}-open`} className="block font-display text-base font-bold text-slate-900 hover:text-[#B01E28] leading-snug break-words">{row.title}</Link>
      <div className="font-mono text-[11px] text-slate-500">{row.kind === "truck" ? "Truck" : "Part"}{row.code ? ` · ${row.code}` : ""}</div>
    </div>
  );
}

export function Missing({ missing, testid, lead = "Not complete yet" }) {
  if (!missing?.length) return null;
  return <p data-testid={testid} className="text-xs text-amber-800 bg-amber-50 border border-amber-200 rounded-md px-2 py-1"><b>{lead}:</b> {missing.join(" · ")}</p>;
}
